import { MediaDimensions } from "@style/media";

export const isMobile = () => window.innerWidth < MediaDimensions.Tablet;
export const isTablet = () => window.innerWidth < MediaDimensions.Desktop;
export const isUltraWide = () => window.innerWidth > MediaDimensions.UltraWide;
